import {
    Component,
    OnInit,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    Input,
    OnChanges,
    SimpleChanges,
    AfterViewInit,
    ChangeDetectorRef,
    ViewChild,
    ElementRef,
    EventEmitter,
    Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Filter, SelectedFilters } from '../../../interfaces/user.interface';

@Component({
    selector: 'mapp-search-input',
    templateUrl: './search-input.component.html',
    styleUrls: ['./search-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SearchInputComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() searchValue: string;

    @Input() activeChat: boolean;

    @Input() dropDownData: Filter[];

    @Input() isSearch = false;

    @Input() isTypingFinished = true;

    @Input() placeholder: string;

    @Output() emitChat = new EventEmitter<string>();

    @Output() emitPause = new EventEmitter<boolean>();

    @Output() emitReset = new EventEmitter<boolean>();

    searchControl: FormControl;

    showFilters = false;

    hasSelectedFilters = true;

    filterAttributes: Filter[];

    selectedFilters: SelectedFilters = {};

    selectedFiltersValues: string[];

    @ViewChild('textarea') textarea: ElementRef;

    valueText: string;

    disableSend = true;

    isTyping = true;

    changeDetectorRef: any;

    uploadTooltip: { visible: boolean; text: string; top: string; left: string } = {
        visible: false,
        text: '',
        top: '0px',
        left: '0px',
    };

    /**
     *
     * @param router
     * @param route
     * @param ref
     * @param elementRef
     */
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private ref: ChangeDetectorRef,
        private elementRef: ElementRef
    ) {}

    /**
     *
     * @param event
     * @param text
     * @param offsetX
     */
    showUploadTooltip(event: MouseEvent, text: string, offsetX = 8) {
        const target = event?.target as HTMLElement | null;
        if (!target) {
            this.uploadTooltip = { visible: true, text, top: '0px', left: '0px' };
            return;
        }
        const rect = target.getBoundingClientRect();
        this.uploadTooltip = { visible: true, text, top: '0px', left: '0px' };
        this.ref.detectChanges();

        requestAnimationFrame(() => {
            const tooltipEl = document.querySelector('.aida-tooltip') as HTMLElement | null;
            if (!tooltipEl) {
                return;
            }
            const tooltipRect = tooltipEl.getBoundingClientRect();
            const top = rect.top + rect.height / 2 - tooltipRect.height / 2;
            let left = rect.right + offsetX;
            if (left + tooltipRect.width > window.innerWidth - 8) {
                left = rect.left - offsetX - tooltipRect.width;
            }
            this.uploadTooltip = {
                visible: true,
                text,
                top: `${Math.max(8, Math.round(top))}px`,
                left: `${Math.max(8, Math.round(left))}px`,
            };
        });
    }

    /**
     *
     */
    hideUploadTooltip() {
        this.uploadTooltip.visible = false;
    }

    /**
     *
     */
    ngAfterViewInit(): void {
        this.isTyping = true;
        this.route.queryParams.subscribe((routerData) => {
            if (routerData.prompt) {
                this.elementRef.nativeElement.querySelector('.textarea').textContent =
                    routerData.prompt;
            }
            if (!this.isSearch && routerData.data) {
                this.selectedFilters = JSON.parse(routerData.data);
                if (this.selectedFilters) {
                    this.setSelectedFiltersValues();
                }
                setTimeout(() => {
                    this.showFilters = true;
                    this.ref.detectChanges();
                }, 3000);
            }
        });
    }

    /**
     *
     */
    ngOnInit(): void {
        this.searchControl = new FormControl('');
        if (!this.isSearch) {
            this.filterAttributes = this.dropDownData;
            this.setupFilters();
        }
        this.isTyping = true;
        this.ref.detectChanges();
    }

    /**
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.searchValue?.currentValue) {
            this.elementRef.nativeElement.querySelector('.textarea').textContent =
                changes?.searchValue?.currentValue;
        }
        if (changes?.isTypingFinished) {
            this.isTyping = changes?.isTypingFinished?.currentValue;
            this.ref.detectChanges();
        }
    }

    /**
     *
     * @param e
     */
    search(e?) {
        this.valueText = this.elementRef.nativeElement.querySelector('.textarea').textContent;
        let component = '/result';
        if (
            this.router.url.indexOf('/searchgtt') > -1 ||
            this.router.url.indexOf('/resultgtt') > -1
        ) {
            component = '/resultgtt';
        }

        let query = {
            prompt: this.valueText,
            data: '',
        };

        if (Object.keys(this.selectedFilters).length) {
            query = {
                prompt: this.valueText,
                data: JSON.stringify(this.selectedFilters),
            };
        }
        if (e) {
            if (e.keyCode === 13) {
                this.router.navigate([component], {
                    queryParams: query,
                });
            }
        } else {
            this.router.navigate([component], {
                queryParams: query,
            });
        }
    }

    /**
     *
     */
    toggleFilters() {
        this.showFilters = !this.showFilters;
    }

    /**
     *
     */
    setSelectedFiltersValues(): void {
        this.selectedFiltersValues = Object.keys(this.selectedFilters).reduce(
            (acc, value) => {
                acc.push(...this.selectedFilters[value]);
                return acc;
            },
            <string[]>[]
        );
        this.hasSelectedFilters = this.selectedFiltersValues.length > 0;
    }

    /**
     *
     */
    setupFilters() {
        this.selectedFilters = {};
        this.filterAttributes.forEach((filter) => {
            this.selectedFilters[filter.fieldName] = [];
        });
    }

    /**
     *
     */
    clearFilters() {
        this.setupFilters();
    }

    /**
     *
     * @param $event
     */
    chat($event) {
        if (this.elementRef.nativeElement.querySelector('.textarea').textContent) {
            this.emitChat.emit(
                this.elementRef.nativeElement.querySelector('.textarea').textContent
            );
            this.elementRef.nativeElement.querySelector('.textarea').textContent = '';
            this.isTyping = false;
        }
        this.emitPause.emit(false);
        $event.stopPropagation();
    }

    /**
     *
     * @param $event
     */
    pause($event) {
        this.emitPause.emit(true);
        this.isTyping = true;
        this.ref.detectChanges();
        $event.stopPropagation();
    }

    /**
     *
     */
    reset() {
        this.emitReset.emit(true);
        this.emitPause.emit(false);
        this.searchValue = '';
        this.valueText = '';
        this.elementRef.nativeElement.querySelector('.textarea').textContent = '';
    }

    /**
     *
     * @param $event
     */
    onKeySearchText($event: any) {
        if ($event.target.innerText === '' && !this.activeChat) {
            this.reset();
        }
    }

    /**
     *
     * @param event
     */
    onPaste(event: any): void {
        // Prevent the default paste behavior to handle it manually
        event.preventDefault();

        // Get the pasted text without formatting
        const pastedText = event.clipboardData ? event.clipboardData.getData('text/plain') : '';

        // Insert the plain text into the editable div
        document.execCommand('insertText', false, pastedText);
    }
}
